  // (function ($) {
//   class Accordian {

//     /**
//     * Constructor.
//     *
//     * @return {void}
//     */
//     constructor() {
//       this.accordianItems = $('.accordion-item');
//       this.contentStyle = $('.accordion-item .partners-content p');
//       this.addEvents();
//     }

//     /**
//     * Add Events.
//     *
//     * @return {void}
//     */
//     addEvents() {

//       this.accordianItems.on('click', (event) => this.setElementActive(event));

//     }

//     /**
//     * Toggle the active class on the target element.
//     *
//     * @return {void}
//     */
//     setElementActive(event) {
//       const targetEl = this.getTargetElement( $(event.target)); 
//       const targetChildId = targetEl.getAttribute( 'data-child-id' );     
//       //const targetChildId = targetElAttrs['data-child-id'];
//       // If clicked element is already active close it.
//       if (targetEl.hasClass('active')) {

//         targetEl.style.height = '200px';
//         targetEl.removeClass('active');
//         return;

//       } else {
//         // Close any open accordions
//         this.closeAll();

//         // Then show the target element.  
//         $(targetEl).addClass('active');
       
//         // Get the size of the content
//         this.setHeight(targetChildId, targetEl);
//       }

//     }

//     /**
//      * Close all open accordions
//      *     
//      * @return {void}
//      *   
//      */
//     closeAll() {
//       var oldActive = document.getElementsByClassName("accordion-item active");
//       var i;
//       for (i = 0; i < oldActive.length; i++) {
//         oldActive[i].style.height = '200px';
//         oldActive[i].classList.remove("active");
//       }
//     }

//     /**
//     * Get the height of the content and set the height of the accordion.
//     *     
//     * @return {void}
//     *   
//     */
//     setHeight(targetChildId, targetEl) {
//       var child = document.getElementById(targetChildId);
//       var childHeight;
//       if ( child ) {
//         childHeight = child.offsetHeight;
//       } else {
//         alert( 'child' . child );
//         childHeight = 250;
//       }
//       // Calculate the final height of the accordion
//       var finalHeight = childHeight + 300;

//       // Set the height of the accordion
//       targetEl.style.height = finalHeight + "px";
      
//     }

//     /**
//     * Get the target element.
//     *
//     * @param eventTarget
//     * @return {null|any|Element}
//     */
//     getTargetElement( eventTarget ) {
//       if ( eventTarget.hasClass( 'accordion-item' ) ) {
//         return eventTarget;
//       } else {
//         return eventTarget.closest( 'accordion-item' );
//       }
//     }
    
//     /**
//     * Get the attributes of the target element.
//     *
//     * @param eventTarget
//     * @return {null|attributes}
//     */
//     getAttributes ( $node ) {
//       var attrs = {};
//       $.each( $node[0].attributes, function ( index, attribute ) {
//           attrs[attribute.name] = attribute.value;
//       } );

//       return attrs;
//     }
    
//   }

//   $( document ).ready( function() {
//     new Accordian();
//   } );


// })(jQuery);



var acc = document.getElementsByClassName("accordion-item");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    if ( this.classList.contains('active') ) {
        this.style.height = '200px';
        $(".accordion-item.active").removeClass("active"); 
    } else {
        
      // close any open accordions
      var oldActive = document.getElementsByClassName("accordion-item active");
       
      for (c = 0; c < oldActive.length; c++) {
          oldActive[c].style.height = '200px';
          oldActive[c].classList.remove("active");   
      }
      // open the clicked accordion
      this.classList.toggle("active");
      childHeight = this.children[1].offsetHeight;
      finalHeight = childHeight + 300;
      this.style.height = finalHeight + "px";
    }
  });
}


// Block Accordion Layout
const accordion_title = document.querySelectorAll(".block-accordion .accordion");

accordion_title.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
    //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});